import { Box, Grid, IconButton, Paper, Tooltip } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { useSortable } from "@dnd-kit/react/sortable";

export function SortablePricingVehicleCard({
  vehicle,
  index,
  children,
  disabled = false,
}) {
  const { ref, handleRef, isDragging } = useSortable({
    id: String(vehicle.id),
    index,
    group: `pricing-vehicles-${vehicle.serviceBooking}`,
    disabled,
  });

  return (
    <Grid
      ref={ref}
      item
      xs={12}
      sm={4}
      md={3}
      marginBottom={2}
      sx={{ position: "relative", zIndex: isDragging ? 1 : "auto" }}
    >
      <Paper
        elevation={isDragging ? 6 : 0}
        sx={{
          height: "100%",
          minHeight: 250,
          borderRadius: 3,
          border: "1px solid rgba(20, 83, 45, 0.12)",
          background: "linear-gradient(180deg, #ffffff 0%, #f8fbfa 100%)",
          p: 2.25,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 0.5 }}>
          <Tooltip
            title={
              disabled
                ? "Guardando cambios..."
                : "Arrastrar para cambiar el orden"
            }
          >
            <span>
              <IconButton
                ref={handleRef}
                size="small"
                disabled={disabled}
                aria-label={`Mover ${vehicle.name}`}
                sx={{
                  color: "#165c53",
                  cursor: isDragging ? "grabbing" : "grab",
                  touchAction: "none",
                }}
              >
                <DragIndicatorIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
        {children}
      </Paper>
    </Grid>
  );
}
